export const VOICE = {
  ctas: {
    acknowledge: "GOT IT",
    next: "NEXT STEP",
    book: "BOOK ASSESSMENT",
  },
  motifs: {
    joints: "Joints first. Muscle second.",
    consistency: "Small blocks. Repeated often.",
    data: "Telemetry tells the truth.",
  },
  labels: {
    protocol: "The Protocol",
    logic: "The Logic",
    tip: "Pro Tip",
  },
};
